export const ActionTypes = {
  CHANGE_PAGE: "CHANGE_PAGE",
  SET_NAME: "SET_NAME",
  DO_ACTION: "DO_ACTION",
  DO_TICK: "DO_TICK",
  CHANGE_ACTION_DEMAND: "CHANGE_ACTION_DEMAND",
  PLAY_LOTTERY: "PLAY_LOTTERY",
  HIRE_WORKER: "HIRE_WORKER",
  ADD_DAILY_INCOME: "ADD_DAILY_INCOME",
  OPEN_BANK_ACCOUNT: "OPEN_BANK_ACCOUNT",
  TRANSFER_MONEY: "TRANSFER_MONEY",
  BANK_ADD_INTEREST: "BANK_ADD_INTEREST",
  BUY_STOCK: "BUY_STOCK",
  UPDATE_STOCK_PRICES: "UPDATE_STOCK_PRICES",
};

export const actions = {
  setName: (name) => ({
    payload: { name },
    type: ActionTypes.SET_NAME,
  }),
  changePage: (currentPage) => ({
    payload: { currentPage },
    type: ActionTypes.CHANGE_PAGE,
  }),
  doAction: (action) => ({
    payload: { action },
    type: ActionTypes.DO_ACTION,
  }),
  doTick: () => ({
    type: ActionTypes.DO_TICK,
  }),
  changeActionDemand: (action) => ({
    payload: { action },
    type: ActionTypes.CHANGE_ACTION_DEMAND,
  }),
  playlottery: (lottery) => ({
    payload: { lottery },
    type: ActionTypes.PLAY_LOTTERY,
  }),
  hireWorker: (worker) => ({
    payload: { worker },
    type: ActionTypes.HIRE_WORKER,
  }),
  addDailyIncome: (action) => ({
    payload: { action },
    type: ActionTypes.ADD_DAILY_INCOME,
  }),
  openBankAccount: (bank) => ({
    payload: { bank },
    type: ActionTypes.OPEN_BANK_ACCOUNT,
  }),
  transferMoney: (to, from, amount) => ({
    payload: { to, from, amount },
    type: ActionTypes.TRANSFER_MONEY,
  }),
  bankAddInterest: () => ({
    type: ActionTypes.BANK_ADD_INTEREST,
  }),
  buyStock: (stock) => ({
    payload: { stock },
    type: ActionTypes.BUY_STOCK,
  }),
  updateStockPrices: (stocks) => ({
    payload: { stocks },
    type: ActionTypes.UPDATE_STOCK_PRICES,
  }),
};
